/**
 * Appends the current query string (useLocation().search: '' or '?…') to an in-app redirect.
 *
 * Campaign links (utm_*, gclid, …) can land on a page that does not load the RVD chatbot
 * (the portal login) or on a curated page that is left before the chatbot script finishes
 * loading. The chatbot reads those parameters from the URL when it loads (story 3066), so
 * redirects into the curated list, vehicle details, and deposit pages carry the query along.
 */
export const withCurrentQuery = (path: string, search: string): string => `${path}${search}`;
